import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = l((o, r) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: r,
    ...o,
    image: (a) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...a,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M14 0a3 3 0 0 0-3 3l-.05 15.934c-.003.772-.835 1.229-1.4.703A8 8 0 0 1 7 13.78V9a2 2 0 1 0-4 0v4.78a12 12 0 0 0 5.916 10.344l.605.356A3 3 0 0 1 11 27.065V31a1 1 0 0 0 1 1h4c.552 0 1-.474 1-1.026V3a3 3 0 0 0-3-3m7.143 11c1.183 0 2.143.881 2.143 1.969l.032 6.6c.003.756.808 1.211 1.34.674.942-.953 1.485-2.207 1.485-3.53 0-.726.64-1.313 1.428-1.313.79 0 1.429.587 1.429 1.312v1c0 2.79-1.608 5.373-4.226 6.788a2.84 2.84 0 0 0-1.488 2.497V31a1 1 0 0 1-1 1H20c-.552 0-1-.462-1-1.014V12.969C19 11.88 19.96 11 21.143 11",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "VeryDryIcon";
export {
  s as VeryDryIcon,
  s as default
};
//# sourceMappingURL=index.js.map
